import UserProductGroupNotificationSettings from '~/Api/User/ProductGroup/NotificationSettings/UserProductGroupNotificationSettings';

import UserProductGroupNotification from './UserProductGroupNotification';

export interface RawNotification {
	settings: { frequency: string };
}

export default function mapUserProductGroupNotification(notification: RawNotification): UserProductGroupNotification {
	return new UserProductGroupNotification(new UserProductGroupNotificationSettings(notification.settings.frequency));
}
